export enum NavigationKeys {
  ArrowDown = "ArrowDown",
  ArrowUp = "ArrowUp",
  ArrowRight = "ArrowRight",
  ArrowLeft = "ArrowLeft",
  Enter = "Enter",
  Tab = "Tab",
  Escape = "Escape",
}
